import { rest } from 'msw'
import type { Contact, ContactInstrument } from 'types/contacts'
import { ContactEntity, InstrumentType, RelationshipType } from 'types/contacts'
import mockContacts from '../../../__mocks__/Contacts/contacts.json'

const API_URL = process.env.API_URL ?? ''

export const CONTACT_INSTRUMENTS_URL = `${API_URL}/platform/v1/contacts/:contactId/instruments`

export const MOCK_CONTACT_ID = '123'

export const MOCK_CONTACT: Contact = {
  id: MOCK_CONTACT_ID,
  name: 'Test Contact',
  defaultReference: '1234567890',
  updatedAt: new Date(),
  createdAt: new Date(),
  relationshipType: RelationshipType.THIRD_PARTY,
  entity: {
    type: ContactEntity.INDIVIDUAL,
    firstName: 'Test',
    lastName: 'Contact',
    dateOfBirth: '1990-01-01',
    address: {
      addressLine1: '123 Main St',
      city: 'Anytown',
      region: 'CA',
      postCode: '12345',
      country: 'US',
    },
  },
  description: 'Test Contact',
}

export const MOCK_BANK_ACCOUNT: ContactInstrument = {
  id: 'instr-1',
  type: InstrumentType.BANK_ACCOUNT,
  currency: 'EUR',
  description: 'Main Bank Account',
  accountNumber: '1234567890',
  accountType: 'Checking',
  paymentMethods: ['SEPA'],
  bank: {
    name: 'Test Bank',
    address: {
      addressLine1: '123 Main St',
      city: 'Anytown',
      region: 'CA',
      postCode: '12345',
      country: 'US',
    },
  },
}

export const MOCK_CRYPTO_INSTRUMENT: ContactInstrument = {
  id: 'instr-2',
  type: InstrumentType.CRYPTO,
  currency: 'ETH',
  description: 'Ethereum Address',
  address: '0xtest456',
}

export const MOCK_INSTRUMENTS = [MOCK_BANK_ACCOUNT, MOCK_CRYPTO_INSTRUMENT]

export const createInstrumentsResponse = (
  instruments: ContactInstrument[] = MOCK_INSTRUMENTS
) => ({
  content: instruments,
  size: 10,
  number: 0,
  totalElements: instruments.length,
})

export const getContacts = rest.get(`${API_URL}/platform/v1/contacts`, async (req, res, ctx) => {
  return res(ctx.json(mockContacts))
})

export const getContactHandler = (contact: Contact = MOCK_CONTACT) =>
  rest.get(`${API_URL}/platform/v1/contacts/:contactId`, (req, res, ctx) => {
    return res(ctx.json(contact))
  })

export const getContactInstrumentsHandler = (
  instruments: ContactInstrument[] = MOCK_INSTRUMENTS
) =>
  rest.get(CONTACT_INSTRUMENTS_URL, (req, res, ctx) => {
    return res(ctx.json(createInstrumentsResponse(instruments)))
  })

export const getContactErrorHandler = () =>
  rest.get(`${API_URL}/platform/v1/contacts/:contactId`, (req, res, ctx) => {
    return res(ctx.status(500))
  })

export const getContactInstrumentsErrorHandler = () =>
  rest.get(CONTACT_INSTRUMENTS_URL, (req, res, ctx) => {
    return res(ctx.status(500))
  })

export const getContactInstrumentsEmptyHandler = () =>
  rest.get(CONTACT_INSTRUMENTS_URL, (req, res, ctx) => {
    return res(ctx.json(createInstrumentsResponse([])))
  })

export const getContactInstrumentsSearchableHandler = (
  instruments: ContactInstrument[] = MOCK_INSTRUMENTS
) =>
  rest.get(CONTACT_INSTRUMENTS_URL, (req, res, ctx) => {
    const query = req.url.searchParams.get('q')
    const filtered = query
      ? instruments.filter(i => i.description.toLowerCase().includes(query.toLowerCase()))
      : instruments
    return res(ctx.json(createInstrumentsResponse(filtered)))
  })

export default [getContacts]
